export default "__VITE_ASSET__TFHpFgKi__"